/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * corporation object
 * @export
 * @interface PostUniverseIdsCorporation
 */
export interface PostUniverseIdsCorporation {
    /**
     * id integer
     * @type {number}
     * @memberof PostUniverseIdsCorporation
     */
    id?: number;
    /**
     * name string
     * @type {string}
     * @memberof PostUniverseIdsCorporation
     */
    name?: string;
}

/**
 * Check if a given object implements the PostUniverseIdsCorporation interface.
 */
export function instanceOfPostUniverseIdsCorporation(value: object): value is PostUniverseIdsCorporation {
    return true;
}

export function PostUniverseIdsCorporationFromJSON(json: any): PostUniverseIdsCorporation {
    return PostUniverseIdsCorporationFromJSONTyped(json, false);
}

export function PostUniverseIdsCorporationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUniverseIdsCorporation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PostUniverseIdsCorporationToJSON(json: any): PostUniverseIdsCorporation {
    return PostUniverseIdsCorporationToJSONTyped(json, false);
}

export function PostUniverseIdsCorporationToJSONTyped(value?: PostUniverseIdsCorporation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

